import isMobile from '../../../lib/isMobile';

const ENV = process.env.NODE_ENV || 'avra';

export default () => ({
  notifications: [],
  isMobile: isMobile(),
  logo: `/logos/${ENV}-logo.svg`,
  logoWhite: `/logos/${ENV}-logo-inverted.svg`,
  activeMenus: [],
  catalogs: {
    filter: '',
    productServiceKey: [],
    sku: [],
    totalPages: 0,
    page: 0,
    count: 0,
  },
  carousel: [
    {
      img: '1.jpg',
      title: 'Catálogo de clientes',
      description: 'Administra tu lista de clientes fácilmente',
      icon: 'account',
      name: 'customers',
    },
    {
      img: '2.jpg',
      title: 'Autofactura',
      description: 'Permite que tus clientes generen sus facturas',
      icon: 'sync',
      name: 'autoinvoice',
    },
    {
      img: '3.jpg',
      title: 'Simplifica la emisión de facturas',
      description: `
        Muévete a una plataforma de facturación para emprendedores, PyMES y empresarios.
        Además, disfruta de servicios incluidos como recibos de nómina,
        notas de crédito, autofactura, y otros más.
      `,
      icon: 'check',
      name: 'simplify',
    },
    {
      img: '4.jpg',
      title: 'Soporte vía chat',
      description: 'Un equipo de expertos siempre disponibles',
      icon: 'message',
      name: 'support',
    },
    {
      custom: true,
      name: 'services',
      component: () => import(/* webpackChunkName: "cfdi-online-benefits" */ '../../../components/Landing/CfdiOnlineBenefits.vue'),
    },
  ],
  catalogSat: {
    bank: [],
    country: [],
    contractType: [],
    currency: [],
    customs: [],
    customsPatent: [],
    deductionType: [],
    hourType: [],
    cfdiUse: [],
    jobRisk: [],
    laborType: [],
    otherPaymentType: [],
    payLeaveType: [],
    paymentForm: [],
    paymentMethod: [],
    paymentPeriodicity: [],
    payrollType: [],
    perceptionType: [],
    regimeType: [],
    relationType: [],
    resourceOrigin: [],
    state: [],
    tax: [],
    taxRateOrFee: [],
    taxRegime: [],
    unitKey: [],
    voucherType: [],
  },
});
